<template>
  <el-drawer
    size="700px"
    :visible.sync="visible"
    direction="rtl"
    :before-close="onClose"
  >
    <div slot="title" class="drawer-header">
      <el-button class="downbtn" type="text" @click="downloadHistory"
        ><i class="el-icon-download"></i> 导出聊天记录</el-button
      >
      <span class="drawer-title">聊天历史记录</span>
    </div>
    <div
      class="chat-history"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <el-scrollbar
        class="chat-history-scrollbar"
        ref="scrollbar"
        id="historyScrollbar"
      >
        <ul>
          <li v-for="(msgInfo, idx) in messages" :key="idx">
            <chat-message-item
              v-if="msgInfo.platform == 'facebook_api'"
              :mode="2"
              :mine="msgInfo.senderId != (msgInfo.chatIdStr?msgInfo.chatIdStr:msgInfo.chatId)"
              :headImage="headImage(msgInfo)"
              :showName="showName(msgInfo)"
              :msgInfo="msgInfo"
              :menu="false"
            >
            </chat-message-item>
            <chat-message-item
              v-else-if="msgInfo.platform == 'customer'"
              :mode="2"
              :mine="msgInfo.senderId == msgInfo.userId"
              :headImage="headImage(msgInfo)"
              :showName="showName(msgInfo)"
              :msgInfo="msgInfo"
              :menu="false"
            >
            </chat-message-item>
            <chat-message-item
              v-else
              :mode="2"
              :mine="msgInfo.senderId == activeAccount[cicadeStore.sendIdKey]"
              :headImage="headImage(msgInfo)"
              :showName="showName(msgInfo)"
              :msgInfo="msgInfo"
              :menu="false"
            >
            </chat-message-item>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </el-drawer>
</template>

<script>
import ChatMessageItem from "./ChatMessageItem.vue";

export default {
  name: "chatHistory",
  components: {
    ChatMessageItem,
  },
  props: {
    visible: {
      type: Boolean,
    },
    chat: {
      type: Object,
    },
    friend: {
      type: Object,
    },
    group: {
      type: Object,
    },
    groupMembers: {
      type: Array,
    },
  },
  data() {
    return {
      messages: [],
      loadAll: false,
      loading: false,
      isLoadingHistory: false, // 是否正在加载历史消息
      oldScrollHeight: null, // 加载历史消息前的滚动高度
      oldMessagesLength: null, // 加载历史消息前的消息长度
      historyPage: 1, // 历史记录页码
      historyPageSize: 15, // 每页数量
      historyTotal: 0, // 总记录数
    };
  },
  methods: {
    onClose() {
      this.messages = [];
      this.loadAll = false;
      this.historyPage = 1;
      this.historyTotal = 0;
      this.resetHistoryLoadingState();
      this.$emit("close");
    },
    // 获取滚动容器
    getScrollWrap() {
      return this.$refs.scrollbar?.$refs?.wrap;
    },
    // 重置触顶加载状态
    resetHistoryLoadingState() {
      this.isLoadingHistory = false;
      this.oldScrollHeight = null;
      this.oldMessagesLength = null;
    },
    // 调整滚动位置
    adjustScrollPosition() {
      if (!this.isLoadingHistory || !this.oldScrollHeight) {
        return;
      }
      
      const scrollWrap = this.getScrollWrap();
      if (!scrollWrap) {
        this.resetHistoryLoadingState();
        return;
      }
      
      const offsetHeight = scrollWrap.scrollHeight - this.oldScrollHeight;
      
      if (offsetHeight > 0) {
        scrollWrap.scrollTop = offsetHeight;
        requestAnimationFrame(() => {
          if (scrollWrap.scrollTop !== offsetHeight) {
            scrollWrap.scrollTop = offsetHeight;
          }
          this.resetHistoryLoadingState();
        });
      } else {
        this.resetHistoryLoadingState();
      }
    },
    downloadHistory() {
      this.$http({
        url: "/client/exportChatHistory",
        method: "post",
        responseType: "blob",
        data: {
          type: "chat",
          account: this.cicadeStore.activeAccount.account,
          channelName: this.cicadeStore.activeAccount.channelName,
          chatIds: [this.cicadeStore.activeChat.chatId],
        },
      }).then((messages) => {
        const blob = new Blob([messages]);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "聊天记录.xlsx";
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    onScroll(e) {
      const scrollWrap = this.getScrollWrap();
      if (!scrollWrap) {
        return;
      }
      
      const scrollTop = scrollWrap.scrollTop;
      
      // 触顶加载历史消息（允许一点误差，避免频繁触发）
      if (scrollTop <= 5 && !this.isLoadingHistory && !this.loadAll && !this.loading) {
        this.loadHistoryMessages();
      }
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$nextTick(() => {
            const scrollWrap = this.getScrollWrap();
            if (scrollWrap) {
              scrollWrap.scrollTop = scrollWrap.scrollHeight;
              // 再次确认滚动到底部
              requestAnimationFrame(() => {
                scrollWrap.scrollTop = scrollWrap.scrollHeight;
              });
            }
          });
        });
      });
    },
    // 初始加载消息
    loadMessages() {
      if (this.loadAll || this.loading) {
        return;
      }

      this.loading = true;
      this.historyPage = 1;
      this.$http({
        url: this.histroyAction,
        method: "get",
        params: {
          accountId: this.$store.state.cicadeStore.activeAccount.accountId,
          chatId: this.$store.state.cicadeStore.activeChat.chatId,
          pageNum: this.historyPage,
          pageSize: this.historyPageSize,
        },
      })
        .then((response) => {
          this.messages = response.list || [];
          this.historyTotal = response.total || 0;
          this.loadAll = this.messages.length >= this.historyTotal;
          this.loading = false;
          // 加载完成后滚动到底部（显示最新消息）
          this.scrollToBottom();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 触顶加载历史消息
    loadHistoryMessages() {
      // 检查是否还有更多消息
      if (this.historyTotal > 0 && this.historyPage * this.historyPageSize >= this.historyTotal) {
        this.loadAll = true;
        return;
      }

      const scrollWrap = this.getScrollWrap();
      if (!scrollWrap) {
        return;
      }

      // 记录加载前的状态
      this.oldScrollHeight = scrollWrap.scrollHeight;
      this.oldMessagesLength = this.messages.length;
      this.isLoadingHistory = true;
      const nextPage = this.historyPage + 1;

      this.$http({
        url: this.histroyAction,
        method: "get",
        params: {
          accountId: this.$store.state.cicadeStore.activeAccount.accountId,
          chatId: this.$store.state.cicadeStore.activeChat.chatId,
          pageNum: nextPage,
          pageSize: this.historyPageSize,
        },
      })
        .then((response) => {
          const newMessages = response.list || [];
          if (newMessages.length > 0) {
            // 更新页码
            this.historyPage = nextPage;
            // 更新总数
            if (response.total !== undefined) {
              this.historyTotal = response.total;
            }
            // 新消息插入到数组前面
            this.messages = [...newMessages, ...this.messages];
            // 检查是否还有更多消息
            if (this.historyTotal > 0) {
              this.loadAll = this.messages.length >= this.historyTotal;
            } else if (newMessages.length < this.historyPageSize) {
              // 如果返回的消息数少于每页数量，说明已经加载完
              this.loadAll = true;
            }
            // 调整滚动位置
            this.$nextTick(() => {
              requestAnimationFrame(() => {
                this.$nextTick(() => {
                  this.adjustScrollPosition();
                });
              });
            });
          } else {
            // 没有新消息，说明已经加载完
            this.loadAll = true;
            this.resetHistoryLoadingState();
          }
        })
        .catch(() => {
          // 加载失败，不更新页码
          this.resetHistoryLoadingState();
        });
    },
    showName(msgInfo) {
      if (this.chat.type == "GROUP") {
        let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
        return member ? member.showNickName : "";
      } else {
        return msgInfo.title;
      }
    },
    headImage(msgInfo) {
      if (this.chat.type == "GROUP") {
        let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
        return member ? member.headImage : "";
      } else {
        return msgInfo.sendId == this.mine.id
          ? this.mine.headImageThumb
          : this.chat.headImage;
      }
    },
  },
  computed: {
    cicadeStore() {
      return this.$store.state.cicadeStore;
    },
    activeAccount() {
      return this.$store.state.cicadeStore.activeAccount;
    },
    mine() {
      return this.$store.state.userStore.userInfo;
    },
    histroyAction() {
      return `/client/historyMessages`;
    },
  },
  watch: {
    visible: {
      handler(newValue) {
        if (newValue) {
          this.loadMessages();
          // 监听滚动事件
          this.$nextTick(() => {
            const scrollWrap = this.getScrollWrap();
            if (scrollWrap) {
              scrollWrap.addEventListener('scroll', this.onScroll);
            }
          });
        } else {
          // 关闭时重置状态
          const scrollWrap = this.getScrollWrap();
          if (scrollWrap) {
            scrollWrap.removeEventListener('scroll', this.onScroll);
          }
          this.messages = [];
          this.loadAll = false;
          this.historyPage = 1;
          this.historyTotal = 0;
          this.resetHistoryLoadingState();
        }
      },
    },
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    const scrollWrap = this.getScrollWrap();
    if (scrollWrap) {
      scrollWrap.removeEventListener('scroll', this.onScroll);
    }
  },
};
</script>

<style lang="scss">
.drawer-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.drawer-title {
  color: #000;
  font-weight: bold;
}

.downbtn {
  position: absolute;
  left: 0px;
}

.chat-history {
  display: flex;
  height: 100%;

  .chat-history-scrollbar {
    flex: 1;

    .el-scrollbar__thumb {
      background-color: #555555;
    }

    ul {
      padding: 20px;

      li {
        list-style-type: none;
      }
    }
  }
}
</style>
